import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useQuery } from '@tanstack/react-query';
import { BatchApiAdapter } from '../adapters/BatchApiAdapter';

export const useBatch = (batchId: number) => {
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new BatchApiAdapter(httpClient);

  return useQuery({
    queryKey: ['batch', batchId],
    queryFn: () => adapter.getBatch(batchId),
    enabled: batchId > 0,
    staleTime: 2 * 60 * 1000,
  });
};

export const useBatchStock = (batchId: number) => {
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new BatchApiAdapter(httpClient);

  return useQuery({
    queryKey: ['batch-stock', batchId],
    queryFn: () => adapter.getBatchStock(batchId),
    enabled: batchId > 0,
    staleTime: 2 * 60 * 1000,
  });
};

export const useBatchTraceability = (batchId: number) => {
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new BatchApiAdapter(httpClient);

  return useQuery({
    queryKey: ['batch-traceability', batchId],
    queryFn: () => adapter.getBatchTraceability(batchId),
    enabled: batchId > 0,
    staleTime: 2 * 60 * 1000,
  });
};

export const useProductBatches = (productId: number) => {
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new BatchApiAdapter(httpClient);

  return useQuery({
    queryKey: ['product-batches', productId],
    queryFn: () => adapter.getProductBatches(productId),
    enabled: productId > 0,
    staleTime: 2 * 60 * 1000,
  });
};
